export default "__VITE_ASSET__DflnKBvu__"